import React, { useContext } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ContextFiles } from '@widgets/Files/model/context';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

import cls from './FileInput.module.css';

interface IFileInputProps {
    onChange: (files: File[], currentFolderId: TFolderId) => void;
}

export const FileInput = ({ onChange }: IFileInputProps) => {
    const { t } = useTranslation();
    const { currentFolderId } = useContext(ContextFiles);
    return (
        <div className={classNames(cls.fieldFileWrapper)}>
            <input
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { files } = e.target;
                    if (files) {
                        onChange(Array.from(files), currentFolderId);
                        e.target.value = '';
                    }
                }}
                name="file"
                type="file"
                id="field__file-3"
                className={classNames(cls.fieldFile)}
                multiple
            />
            <label className={classNames(cls.fieldFileWrapper)} htmlFor="field__file-3">
                <div className={classNames(cls.fieldFileButton)}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12.2667 7.36686H8.63335V3.73353C8.63335 3.3839 8.34964 3.1002 8.00001 3.1002C7.65039 3.1002 7.36668 3.3839 7.36668 3.73353V7.36686H3.73335C3.38372 7.36686 3.10001 7.65057 3.10001 8.0002C3.10001 8.34982 3.38372 8.63353 3.73335 8.63353H7.36668V12.2669C7.36668 12.6165 7.65039 12.9002 8.00001 12.9002C8.34964 12.9002 8.63335 12.6165 8.63335 12.2669V8.63353H12.2667C12.6163 8.63353 12.9 8.34982 12.9 8.0002C12.9 7.65057 12.6163 7.36686 12.2667 7.36686Z"
                            fill="#F5F5F5"
                            stroke="#F5F5F5"
                            strokeWidth="0.2"
                        />
                    </svg>
                    {t('FileInput.return.fieldFileButton')}
                </div>
            </label>
        </div>
    );
};
